import { platformApiFetch } from '@/services/platformApi/client';
import { ServiceProviderRow } from '@/types/supabase';

export interface ServiceProviderCreateData {
  name: string;
  category: string;
  categories: string[];
  description: string;
  suburbs: string[];
  website_url?: string | null;
  image_url: string;
}

export interface ServiceProviderUpdateData {
  name?: string;
  category?: string;
  categories?: string[];
  description?: string;
  suburbs?: string[];
  website_url?: string | null;
  image_url?: string;
}

interface UserServiceProvider {
  id: string;
  name: string;
  status: string;
  whatsapp_verified: boolean | null;
  is_verified: boolean;
}

export async function createServiceProvider(data: ServiceProviderCreateData): Promise<ServiceProviderRow[]> {
  return platformApiFetch<ServiceProviderRow[]>('/v1/provider-owner', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateServiceProvider(id: string, data: ServiceProviderUpdateData): Promise<ServiceProviderRow[]> {
  return platformApiFetch<ServiceProviderRow[]>(`/v1/provider-owner/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function getUserServiceProviderCount(userId: string): Promise<number> {
  return platformApiFetch<number>(`/v1/provider-owner/count/${userId}`);
}

export async function deleteServiceProvider(id: string): Promise<void> {
  await platformApiFetch(`/v1/provider-owner/${id}`, { method: 'DELETE' });
}

export async function getUserServiceProviders(userId: string, statusFilter?: string): Promise<ServiceProviderRow[]> {
  const query = statusFilter ? `?statusFilter=${encodeURIComponent(statusFilter)}` : '';
  return platformApiFetch<ServiceProviderRow[]>(`/v1/provider-owner/user/${userId}${query}`);
}

export async function fetchUserServiceProviders(userId: string): Promise<UserServiceProvider[]> {
  return platformApiFetch<UserServiceProvider[]>(`/v1/provider-owner/minimal/${userId}`);
}

export async function fetchUserServiceProviderById(listingId: string, userId: string): Promise<ServiceProviderRow | null> {
  return platformApiFetch<ServiceProviderRow | null>(`/v1/provider-owner/${listingId}?userId=${encodeURIComponent(userId)}`);
}